import * as React from 'react';

import PropTypes from 'prop-types';
import * as ramda from 'ramda';

import {deserializeUrlParam} from 'nutshell-core/deserialize-url-param';
import * as Schema from 'nutshell-core/schema';
import type {FilterObject, UnserializedFilterObject} from 'nutshell-core/types';

import {FilterCapsule} from 'shells/filter-capsule/filter-capsule';

const filters = ['funnelPeriod', 'owner', 'tags', 'sources', 'competitors', 'products'];

type Props = {
    filters: FilterObject;
    schema: Schema.Properties;
    onFilterRemove: (arg1: string) => void;
    // @ts-expect-error
    onFilterSubmit: PropTypes.func.isRequired;
};

export class FunnelReportFilters extends React.Component<Props> {
    render() {
        // @ts-expect-error
        const filterSchema = ramda.filter((field) => filters.includes(field.name));
        const fields = filterSchema(this.props.schema);

        return (
            <div className='ui-funnel-report__filter-container'>
                {ramda.values(
                    // @ts-expect-error
                    ramda.map((field) => {
                        field.isAndable = false;

                        // Remove nullOption filtering (no assignee, no source)
                        // from funnel report filters options, we don't support
                        // these on the backend.
                        // @ts-expect-error
                        if (field.nullOptionText) {
                            // @ts-expect-error
                            delete field.nullOptionText;
                        }

                        return (
                            <FilterCapsule
                                key={field.name}
                                schemaField={field}
                                filter={this.props.filters[field.name]}
                                filterName={field.name}
                                onSubmit={this.handleFilterUpdate}
                                // @ts-expect-error
                                onUpdate={this.handleFilterUpdate}
                                onRemove={this.handleFilterRemove}
                                defaultValueTitle={
                                    field.name === 'funnelPeriod'
                                        ? 'Date range: Current month'
                                        : undefined
                                }
                            />
                        );
                    }, fields)
                )}
            </div>
        );
    }

    handleFilterUpdate = (filterObj: UnserializedFilterObject<any>, filterName: string) => {
        const filterKey = Object.keys(filterObj)[0];
        // @ts-expect-error
        const filterData = filterObj[filterKey];

        // We expect an object with a key
        const deserializedFilterObj = {
            // @ts-expect-error
            [filterKey]: deserializeUrlParam(filterData, this.props.schema[filterName].type),
        } as const;

        this.props.onFilterSubmit(deserializedFilterObj);
    };

    handleFilterRemove = (filterKey: string) => {
        this.props.onFilterRemove(filterKey);
    };
}
